export default __webpack_public_path__ + "open-roll-top-fix.jpg";